export const EMAIL_OTP_LENGTH = 6;
export const NON_DIGIT_PATTERN = /\D/g;
